import { ButtonHTMLAttributes, MouseEvent, ReactNode } from 'react';

// this is the only place we should be importing these
import { Button as USButton, ButtonType, ButtonSize } from 'us-react-components/dist/Button/Button';

import { useDependencies } from '../../dependencies';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonType?: ButtonType;
  buttonSize?: ButtonSize;
  children?: ReactNode;
}

const Button = (props: Props): JSX.Element => {
  const { children, onClick, ...rest } = props;

  const {
    services: { tracker },
  } = useDependencies();

  const handleClick = (e: MouseEvent<HTMLButtonElement>): void => {
    const trackingProps = {
      elementId: e.currentTarget.id,
      elementName: e.currentTarget.name,
      elementText: e.currentTarget.innerText,
    };

    void tracker.track('clicked-button', trackingProps);

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <USButton onClick={handleClick} {...rest}>
      {children}
    </USButton>
  );
};

export { Button, ButtonType, ButtonSize };
